import { endpoints, settings } from "@config/settings";
import { Logo, LogoDTO } from "@models/logo";
import { HttpService } from "./http-service";

export class LogosService {
  private http = HttpService;

  async getLogos(): Promise<Logo[]> {
    const url = `${settings.BIOVERT_CMS}${endpoints.cms.logos}`;
    const response = await this.http.get<LogoDTO[]>(url);
    const results = new Logo().deserializeArray(response.data);
    return results;
  }
}
